export const avatars = [
    {
        lottieSrc: 'images/visitante.png',
        textImg: 'images/visitante-texto.png',
        name: 'novato'
    },
    {
        lottieSrc: 'images/realejero.png',
        textImg: 'images/realejero-texto.png',
        name: 'experto'
    },
];
export const preloadResources = [
    {
        src: "images/los_realejos_logo.png",
        linkAs: "image"
    },
    {
        src: "images/heart.svg",
        linkAs: "image"
    },
    {
        src: "images/timer.svg",
        linkAs: "image"
    },
    {
        src: "images/trophy.svg",
        linkAs: "image"
    },
];
